export default {
  title: "计算历史",
  type: "类型",
  routeSearch: "路线搜索",
  batchId: "批次ID",
  createdAt: "创建时间",
  totalDistance: "总距离 (km)",
  productionEmission: "生产排放 (kg CO2e)",
  transportEmission: "运输排放 (kg CO2e)",
  totalEmission: "总排放 (kg CO2e)",
  taxInEUR: "税费 (€)",
  action: "操作",
  detail: "详情",
  deleteConfirm: "确定要删除此记录吗？",
  data: "数据",
  reports: "报告",
  batchDownload: "批量下载",
  batchDownloadPdf: "批量下载PDF",
  batchDownloadExcel: "批量下载Excel",
  selectPlaceholder: "请至少选择一条记录",
  quotaInsufficient: "配额不足，请升级或购买",
  batchDownloadSuccess: "批量下载完成，选择已重置",
  batchDownloadFailed: "批量下载失败",
  emptyFile: "生成的文件为空",
  downloadProgress: "下载进度",
  completed: "已完成",
  but: "但是",
  regenerate: "重新生成",
};
